export function defaultMetaTagsBuilder({
  title,
  url,
  image,
  description,
}: {
  title: string;
  url: URL;
  image?: string;
  description?: string;
}) {
  return [
    { title: title },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:url",
      content: url.href,
    },
    {
      property: "og:title",
      content: title,
    },
    {
      property: "og:image",
      content:
        image ??
        "https://app.7qz.io/cdn-cgi/image/fit=contain,format=auto,dpi=2/7qz-link-image.svg",
    },
    {
      name: "description",
      content: description ?? "7qz.io - EVERY SPORT EVERY TEAM GAMIFIED",
    },
  ];
}
